module.exports = __webpack_public_path__ + "img/user-admin.20abe52f.png";